// ============================================
// Environment Configuration
// ============================================

interface EnvConfig {
  apiBaseUrl: string;
  apiTimeout: number;
  isDevelopment: boolean;
  isProduction: boolean;
  appName: string;
  appVersion: string;
}

function getEnvConfig(): EnvConfig {
  const isDevelopment = import.meta.env.DEV;
  const isProduction = import.meta.env.PROD;

  return {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://192.168.1.186:8080/api/v1',
    apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
    isDevelopment,
    isProduction,
    appName: 'ConAI Store Admin',
    appVersion: '1.0.0',
  };
}

export const env = getEnvConfig();

// Type augmentation for Vite env
declare global {
  interface ImportMetaEnv {
    readonly DEV: boolean;
    readonly PROD: boolean;
    readonly VITE_API_BASE_URL: string;
    readonly VITE_API_TIMEOUT: string;
  }

  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}
